/* Debug Toolbar Styles */
.debug-toolbar {
  position: fixed;
  bottom: var(--bottom);
  left: var(--left);
  top: var(--top);
  right: var(--right);
  transform: translateX(var(--translateX, 0)) translateY(var(--translateY, 0));
  z-index: 10000;
  font-family: system-ui, -apple-system, sans-serif;
  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  padding: 10px;
}

.debug-toolbar[data-visible="false"] {
  display: none;
}

.debug-toolbar-container {
  background: linear-gradient(135deg, #1e1e1e 0%, #2a2a2a 100%);
  border: 1px solid #444;
  border-radius: 24px;
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.25);
  padding: 4px 8px;
  display: flex;
  gap: 4px;
  align-items: center;
  height: 40px;
}

.debug-toolbar-icon-button {
  background: transparent;
  border: none;
  color: #9ca3af;
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  transition: all 0.2s ease;
  position: relative;
}

.debug-toolbar-icon-button:hover {
  background: rgba(102, 126, 234, 0.1);
  color: #a5b4fc;
  transform: scale(1.05);
}

.debug-toolbar-icon-button.active {
  background: rgba(102, 126, 234, 0.2);
  color: #667eea;
}

.debug-toolbar-icon-button:after {
  content: attr(data-tooltip);
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%) translateY(-8px);
  background: #1e1e1e;
  color: #e0e0e0;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s;
  border: 1px solid #444;
}
div[data-position^="top"] .debug-toolbar-icon-button:after {
  bottom: unset;
  top: 100%;
  transform: translateX(-50%) translateY(8px);
}

.debug-toolbar-icon-button:hover:after {
  opacity: 1;
}

.debug-toolbar-separator {
  width: 1px;
  height: 32px;
  background: #444;
  margin: 0 8px;
}

.debug-toolbar-panel {
  position: absolute;
  background: #1e1e1e;
  border: 1px solid #444;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  width: 400px;
  max-height: 500px;
  overflow-y: auto;
  display: none;
  color: #e0e0e0;
  left: var(--left-panel);
  right: var(--right-panel);
  bottom: var(--bottom-panel);
  top: var(--top-panel);
  transform: translateX(var(--translateX-panel));
}

.debug-toolbar-panel.open {
  display: block;
}

/* Animation for bottom panels */
.debug-toolbar-panel.open {
  animation: slideInPanel 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes slideInPanel {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.debug-toolbar-header {
  padding: 16px;
  border-bottom: 1px solid #333;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.debug-toolbar-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #fff;
}

.debug-toolbar-section {
  padding: 16px;
  border-bottom: 1px solid #333;
}

.debug-toolbar-section:last-child {
  border-bottom: none;
}

.debug-toolbar-section h4 {
  margin: 0 0 12px 0;
  font-size: 14px;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.debug-toolbar-control {
  margin-bottom: 12px;
}

.debug-toolbar-control:last-child {
  margin-bottom: 0;
}

.debug-toolbar-control label {
  display: block;
  font-size: 12px;
  color: #9ca3af;
  margin-bottom: 4px;
}

.debug-toolbar-control select,
.debug-toolbar-control input {
  width: 100%;
  padding: 8px;
  background: #2a2a2a;
  border: 1px solid #444;
  border-radius: 6px;
  color: #e0e0e0;
  font-size: 14px;
}

.debug-toolbar-control select:focus,
.debug-toolbar-control input:focus {
  outline: none;
  border-color: #667eea;
}

.debug-toolbar-control select:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.debug-toolbar-control label.debug-toolbar-checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
}
.debug-toolbar-control label.debug-toolbar-checkbox input {
  width: auto;
}

.relative {
  position: relative;
}

.absolute {
  position: absolute;
}

.inset-y-0 {
  top: 0;
  bottom: 0;
}

.right-8 {
  right: 8px;
}

.flex {
  display: flex;
}

.flex-col {
  flex-direction: column;
}

.items-center {
  align-items: center;
}

.justify-between {
  justify-content: space-between;
}

.gap-2 {
  gap: 8px;
}

.gap-4 {
  gap: 16px;
}

.ml-auto {
  margin-left: auto;
}

.pointer-events-none {
  pointer-events: none;
}

.h-4 {
  height: 16px;
}

.w-4 {
  width: 16px;
}

.text-gray-500 {
  color: #9ca3af;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.animate-spin {
  animation: spin 1s linear infinite;
}

.debug-toolbar-button {
  padding: 8px 16px;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  transition: background 0.2s;
  font-weight: 500;
}

.debug-toolbar-button:hover {
  background: #5568d3;
}

.debug-toolbar-button.secondary {
  background: #444;
}

.debug-toolbar-button.secondary:hover {
  background: #555;
}

.debug-toolbar-button-group {
  display: flex;
  gap: 8px;
}

.debug-toolbar-button-link {
  background: transparent;
  color: #667eea;
  border: none;
  font-size: 13px;
  text-decoration: underline;
  cursor: pointer;
  transition: color 0.2s;
}

.debug-toolbar-info {
  font-size: 12px;
  color: #9ca3af;
  padding: 8px;
  background: #2a2a2a;
  border-radius: 6px;
  margin-top: 8px;
}

.debug-toolbar-info code {
  color: #a5b4fc;
  font-family: "Courier New", monospace;
}

.debug-toolbar-control.inline-text {
  display: flex;
  align-items: center;
  gap: 4px;
}
.debug-toolbar-control.inline-text select {
  width: auto;
  padding: 0;
  border: none;
  font-size: 14px;
  font-family: "Courier New", monospace;
  text-decoration: underline;
  cursor: pointer;
}
